<template>
  <div class="prose prose-lg max-w-none" v-if="hasCustomTermsBody" v-html="localizedTerms" />
  <div class="prose prose-lg max-w-none" v-else>
    <h2>{{ $t('terms.organizer') }}</h2>
    <p class="font-bold">
      {{ customer.name }}
    </p>
    <p>
      {{ customer.address }}
    </p>
    <p>
      {{ customer.zip }} {{ customer.city }}
    </p>
    <p>
      <span class="font-bold">{{ $t('terms.vat') }}:</span> {{ customer.vat }}
    </p>
    <p>
      <span class="font-bold">{{ $t('terms.contact_person') }}:</span> {{ customer.contact }}
    </p>
    <p>
      <span class="font-bold">{{ $t('terms.phone') }}:</span> {{ customer.telephone }}
    </p>
    <p>
      <span class="font-bold">{{ $t('terms.email') }}:</span> {{ customer.email }}
    </p>

    <h2>{{ $t('terms.sales_delivery_terms') }}</h2>
    <p>
      {{ $t('terms.applicable_for') }}:
    </p>
    <p class="font-bold">
      {{ legalEntity.name }}
    </p>
    <p>
      {{ legalEntity.street }}
    </p>
    <p>
      {{ legalEntity.city }}
    </p>
    <p>
      {{ $t('terms.phone') }}: {{ legalEntity.phone }}
    </p>
    <p>
      {{ $t('terms.email') }}: {{ legalEntity.email }}
    </p>
    <p>
      {{ $t('terms.vat') }}: {{ legalEntity.cvr }}
    </p>

    <p>{{ $t('terms.hereafter_referred') }} {{ legalEntity.name }}</p>

    <h3>§ 1. {{ $t('terms.general') }}</h3>
    <p>{{ $t('terms.general_clause_1') }}</p>
    <p>{{ legalEntity.name }} {{ $t('terms.general_clause_2') }}</p>

    <h3>§ 2. {{ $t('terms.payment') }}</h3>
    <p>{{ $t('terms.payment_clause_1') }}</p>
    <p>{{ $t('terms.payment_clause_2') }}</p>
    <p>{{ $t('terms.payment_clause_3') }}</p>

    <h3>§ 3. {{ $t('terms.delivery') }}</h3>
    <p>{{ $t('terms.delivery_clause_1') }}</p>
    <p>{{ $t('terms.delivery_clause_2') }}</p>

    <h3>§ 4. {{ $t('terms.privacy') }}</h3>
    <p>{{ $t('terms.privacy_clause_1', { name: legalEntity.name }) }}</p>
    <p>{{ $t('terms.privacy_clause_2', { name: legalEntity.name }) }}</p>
    <p>{{ $t('terms.privacy_clause_3') }}</p>
    <p>{{ $t('terms.privacy_clause_4', { name: legalEntity.name }) }}</p>

    <h3>§ 5. {{ $t('terms.liability') }}</h3>
    <p>{{ $t('terms.liability_clause_1') }}</p>
    <p>{{ $t('terms.liability_clause_2') }}</p>
    <p>{{ $t('terms.liability_clause_3') }}</p>
    <p>{{ $t('terms.liability_clause_4') }}</p>
    <p>{{ $t('terms.liability_clause_5', { name: legalEntity.name }) }}</p>
    <p>{{ $t('terms.liability_clause_6') }}</p>
    <p>{{ $t('terms.liability_clause_7') }}</p>

    <h3>§ 6. {{ $t('terms.refund') }}</h3>
    <p>{{ $t('terms.refund_clause_1', { name: legalEntity.name }) }}</p>
    <p><strong>{{ $t('terms.refund_clause_2') }}</strong></p>

    <h3>§ 7. {{ $t('terms.changes') }}</h3>
    <p>{{ $t('terms.changes_clause_1', { name: legalEntity.name }) }}</p>

    <h3>§ 8. {{ $t('terms.law') }}</h3>
    <p>{{ $t('terms.law_clause_1') }}</p>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';

  import { useGeneralStore } from '@/stores/general';
  import { getLocalizedCustomerValue } from '@/utils/customerUtil';

  const { locale } = useI18n();
  const generalStore = useGeneralStore();
  const customer = computed(() => generalStore.customer());

  const localizedTerms = computed(() => getLocalizedCustomerValue(customer.value, locale.value, 'terms_text'));
  const hasCustomTermsBody = computed(() => customer.value.terms_localization_active && localizedTerms.value.trim().length > 0);

  const legalEntity = computed(() => {
    if (customer.value.cashflow === 1) {
      return {
        name: customer.value.name,
        street: customer.value.address,
        city: `${customer.value.zip} ${customer.value.city}`,
        phone: customer.value.telephone,
        email: customer.value.email,
        cvr: customer.value.vat,
      };
    } else {
      return {
        name: 'Safeticket A/S',
        street: 'Gunnar Clausens Vej 26B',
        city: '8260 Viby',
        phone: '7020 4720',
        email: 'info@safeticket.dk',
        cvr: '31184924',
      };
    }
  });
</script>
